import { render, staticRenderFns } from "./GreenChannel.vue?vue&type=template&id=ecb02282&scoped=true&"
import script from "./GreenChannel.vue?vue&type=script&lang=js&"
export * from "./GreenChannel.vue?vue&type=script&lang=js&"
import style0 from "./GreenChannel.vue?vue&type=style&index=0&id=ecb02282&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecb02282",
  null
  
)

component.options.__file = "GreenChannel.vue"
export default component.exports